import React, { useEffect, useState } from "react";

import {
    Alert,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FilledInput,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import DateFieldComponent from "common/components/DateFieldComponent/DateFieldComponent";
import SelectProvinceAndLocation from "common/components/SelectProvinceAndLocation/SelectProvinceAndLocation";
import { ApiService } from "common/services/ApiService";
import dayjs from "dayjs";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const SignUpForm = ({
    handleSignUp,
    signUpFormData,
    setSignUpFormData,
    handleChangeForms,
    handleClose,
    setShowError,
    showError,
    errorMessage,
    loggedByGoogle = false,
}) => {
    // const [provinces, setProvinces] = useState([]);
    // const [locations, setLocations] = useState([]);
    const [establishments, setEstablishments] = useState([]);
    const [errorPasswordLength, setErrorPasswordLength] = useState(false);
    const [errorPasswordMessage, setErrorPasswordMessage] = useState("");

    // useEffect(() => {
    //     async function getProvinces() {
    //         const res = await ApiService.getProvinces();
    //         setProvinces(res.data);
    //     }

    //     getProvinces();
    // }, []);

    // const getLocations = async (provinceId) => {
    //     const res = await ApiService.getLocations(provinceId);
    //     setLocations(res.data);
    // };

    const getEstablishments = async (locationId) => {
        const res = await ApiService.getEstablishments(
            null,
            null,
            { location: locationId },
            false
        );
        setEstablishments(res.data.results);
    };

    const handleChangeProvince = (evt) => {
        setSignUpFormData({
            ...signUpFormData,
            province: evt.target.value,
        });
        // getLocations(evt.target.value);
    };

    const handleChangeLocation = (option) => {
        setSignUpFormData({
            ...signUpFormData,
            city: option?.id,
        });
        // getEstablishments(option?.id);
    };

    const handleChangeEstablishment = (option) => {
        setSignUpFormData({
            ...signUpFormData,
            establishments: [option?.id],
        });
    };

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <form onSubmit={(evt) => handleSignUp(evt)}>
                <DialogTitle sx={{ width: { md: "500px" } }}>
                    {!loggedByGoogle ? "Registrarse" : "Completar registro"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Registro de usuario para solicitar acceso a la
                        plataforma AlfaDatizando
                    </DialogContentText>
                    {!loggedByGoogle && (
                        <>
                            <TextField
                                required
                                inputProps={{
                                    autoComplete: "new-password",
                                }}
                                autoFocus={!loggedByGoogle}
                                margin="dense"
                                id="name"
                                label="Nombre"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={(evt) => {
                                    setSignUpFormData({
                                        ...signUpFormData,
                                        firstName: evt.target.value,
                                    });
                                }}
                            />
                            <TextField
                                required
                                inputProps={{
                                    autoComplete: "new-password",
                                }}
                                margin="dense"
                                id="lastName"
                                label="Apellido"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={(evt) => {
                                    setSignUpFormData({
                                        ...signUpFormData,
                                        lastName: evt.target.value,
                                    });
                                }}
                            />
                            <TextField
                                inputProps={{
                                    autoComplete: "new-password",
                                }}
                                required
                                defaultValue=""
                                margin="dense"
                                id="email"
                                label="Email"
                                type="email"
                                fullWidth
                                helperText="Será tu usuario para iniciar sesión"
                                variant="standard"
                                onChange={(evt) => {
                                    setSignUpFormData({
                                        ...signUpFormData,
                                        email: evt.target.value,
                                    });
                                }}
                            />
                        </>
                    )}
                    <TextField
                        inputProps={{
                            autoComplete: "new-password",
                        }}
                        autoComplete="off"
                        required
                        autoFocus={loggedByGoogle}
                        margin="dense"
                        id="dni"
                        label="DNI"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={(evt) => {
                            setSignUpFormData({
                                ...signUpFormData,
                                dni: evt.target.value,
                            });
                        }}
                    />

                    <DateFieldComponent
                        label="Fecha de nacimiento"
                        handleChange={(evt) => {
                            setSignUpFormData({
                                ...signUpFormData,
                                birthday: dayjs(evt).format("YYYY-MM-DD"),
                            });
                        }}
                    ></DateFieldComponent>

                    <div style={{ marginTop: "20px" }}>
                        <SelectProvinceAndLocation
                            // value={signUpForm.province}
                            handleChangeProvince={handleChangeProvince}
                            handleChangeLocation={handleChangeLocation}
                            handleChangeEstablishment={
                                handleChangeEstablishment
                            }
                            showEstablishments
                            gridSizes={{
                                province: { xs: 12, lg: 6, sm: 6 },
                                location: { xs: 12, lg: 6, sm: 6 },
                                establishment: { xs: 12, lg: 12, sm: 12 },
                            }}
                            useToken={false}
                        ></SelectProvinceAndLocation>
                    </div>

                    {!loggedByGoogle && (
                        <>
                            {/* <TextField
                                autoFocus
                                margin="dense"
                                id="password"
                                label="Contraseña"
                                type="password"
                                fullWidth
                                variant="standard"
                                onChange={(evt) => {
                                    setSignUpFormData({
                                        ...signUpFormData,
                                        password: evt.target.value,
                                    });
                                }}
                            /> */}
                            <FormControl
                                variant="standard"
                                fullWidth
                                margin="dense"
                                required
                            >
                                <InputLabel>Contraseña</InputLabel>
                                <Input
                                    inputProps={{
                                        autoComplete: "new-password",
                                    }}
                                    fullWidth
                                    type={showPassword ? "text" : "password"}
                                    onChange={(evt) => {
                                        if (evt.target.value.length < 8) {
                                            setErrorPasswordMessage(
                                                "La contraseña debe tener al menos 8 caracteres"
                                            );
                                            setErrorPasswordLength(true);
                                        } else {
                                            setErrorPasswordLength(false);
                                        }
                                        setSignUpFormData({
                                            ...signUpFormData,
                                            password: evt.target.value,
                                        });
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={
                                                    showPassword
                                                        ? "Ocultar"
                                                        : "Ver"
                                                }
                                                onClick={
                                                    handleClickShowPassword
                                                }
                                                onMouseDown={
                                                    handleMouseDownPassword
                                                }
                                                onMouseUp={
                                                    handleMouseUpPassword
                                                }
                                                edge="end"
                                            >
                                                {showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                {errorPasswordLength && (
                                    <Typography variant="caption" color="error">
                                        {errorPasswordMessage}
                                    </Typography>
                                )}
                            </FormControl>

                            <FormControl
                                required
                                variant="standard"
                                fullWidth
                                margin="dense"
                            >
                                <InputLabel htmlFor="password2">
                                    Repetir contraseña
                                </InputLabel>
                                <Input
                                    inputProps={{
                                        autoComplete: "new-password",
                                    }}
                                    fullWidth
                                    id="password2"
                                    type={showPassword ? "text" : "password"}
                                    onChange={(evt) => {
                                        setSignUpFormData({
                                            ...signUpFormData,
                                            repeatedPassword: evt.target.value,
                                        });
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={
                                                    showPassword
                                                        ? "Ocultar"
                                                        : "Ver"
                                                }
                                                onClick={
                                                    handleClickShowPassword
                                                }
                                                onMouseDown={
                                                    handleMouseDownPassword
                                                }
                                                onMouseUp={
                                                    handleMouseUpPassword
                                                }
                                                edge="end"
                                            >
                                                {showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>

                            {/* <TextField
                                autoFocus
                                margin="dense"
                                id="password2"
                                label="Repetir contraseña"
                                type="password"
                                fullWidth
                                variant="standard"
                                onChange={(evt) => {
                                    setSignUpFormData({
                                        ...signUpFormData,
                                        repeatedPassword: evt.target.value,
                                    });
                                }}
                            /> */}
                        </>
                    )}
                    <div>
                        <FormControlLabel
                            checked={signUpFormData.isStudent}
                            onChange={(evt) =>
                                setSignUpFormData({
                                    ...signUpFormData,
                                    isStudent: evt.target.checked,
                                    isTeacher: false,
                                    isAdmin: false,
                                })
                            }
                            control={<Switch color="primary" />}
                            label={
                                <p style={{ margin: "0px" }}>
                                    Registrarse como <strong>Estudiante</strong>
                                </p>
                            }
                            labelPlacement="start"
                            sx={{ margin: "5px 0px" }}
                        />
                    </div>

                    <div>
                        <FormControlLabel
                            checked={signUpFormData.isTeacher}
                            onChange={(evt) => {
                                const isChecked = evt.target.checked;
                                setSignUpFormData({
                                    ...signUpFormData,
                                    isTeacher: isChecked,
                                    isStudent:
                                        !isChecked && !signUpFormData.isAdmin,
                                });
                            }}
                            control={<Switch color="primary" />}
                            label={
                                <p style={{ margin: "0px" }}>
                                    Registrarse como <strong>Profesor</strong>
                                </p>
                            }
                            labelPlacement="start"
                            sx={{ margin: "5px 0px" }}
                        />
                    </div>

                    <div>
                        <FormControlLabel
                            checked={signUpFormData.isAdmin}
                            onChange={(evt) => {
                                const isChecked = evt.target.checked;
                                setSignUpFormData({
                                    ...signUpFormData,
                                    isAdmin: isChecked,
                                    isStudent:
                                        !isChecked && !signUpFormData.isTeacher,
                                });
                            }}
                            control={<Switch color="primary" />}
                            label={
                                <p style={{ margin: "0px" }}>
                                    Registrarse como{" "}
                                    <strong>Administrador</strong>
                                </p>
                            }
                            labelPlacement="start"
                            sx={{ margin: "5px 0px" }}
                        />
                    </div>
                    {!loggedByGoogle && (
                        <div style={{ marginTop: "10px" }}>
                            <Typography variant="p">
                                <small>
                                    Ya tienes cuenta?{" "}
                                    <Typography
                                        variant="p"
                                        sx={{
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                        color={"primary.dark"}
                                        onClick={() => {
                                            handleChangeForms();
                                        }}
                                    >
                                        Inicia sesión
                                    </Typography>
                                </small>
                            </Typography>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="contained"
                        sx={{ backgroundColor: "primary.light" }}
                    >
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained">
                        Registrarse
                    </Button>
                </DialogActions>
            </form>
            {showError === true ? (
                <Grid
                    item
                    xs={12}
                    md={7}
                    sx={{
                        position: "fixed",
                        top: "45%",
                        left: "33%",
                        zIndex: 9999,
                    }}
                >
                    <Alert severity="error" variant="filled">
                        {errorMessage}
                    </Alert>
                </Grid>
            ) : null}
        </>
    );
};

export default SignUpForm;
